"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const style_overider_1 = __importDefault(require("utils/style-overider"));
const button_style_1 = __importDefault(require("../button.style"));
const kendo_react_indicators_1 = require("@progress/kendo-react-indicators");
const ButtonComponent = (_a) => {
    var _b, _c;
    var { children, isLoading = false } = _a, props = __rest(_a, ["children", "isLoading"]);
    return ((0, jsx_runtime_1.jsxs)("button", Object.assign({}, props, { style: Object.assign(Object.assign({}, (0, style_overider_1.default)(button_style_1.default.buttonStyle, props.style)), { border: (_b = props.style) === null || _b === void 0 ? void 0 : _b.backgroundColor, backgroundColor: (_c = props.style) === null || _c === void 0 ? void 0 : _c.backgroundColor }) }, { children: [children, isLoading && ((0, jsx_runtime_1.jsx)("div", Object.assign({ "data-testid": 'loader-testid' }, { children: (0, jsx_runtime_1.jsx)(kendo_react_indicators_1.Loader, { type: 'pulsing', style: { marginLeft: 4, color: 'white' } }) })))] })));
};
exports.default = ButtonComponent;
